import * as yup from 'yup'
import cpf from './cpf'
import cellphone from './cellphone'
import plate from './plate'
import atLeastOneCharacter from './atLeastOneCharacter'
import atLeastOneNumber from './atLeastOneNumber'
import rntrc from './rntrc'

yup.addMethod(yup.string, 'cpf', cpf)
yup.addMethod(yup.string, 'cellphone', cellphone)
yup.addMethod(yup.string, 'plate', plate)
yup.addMethod(yup.string, 'atLeastOneCharacter', atLeastOneCharacter)
yup.addMethod(yup.string, 'atLeastOneNumber', atLeastOneNumber)
yup.addMethod(yup.string, 'rntrc', rntrc)

yup.setLocale({
  mixed: {
    required: 'Preenchimento obrigatório',
  },
})

export * from 'yup'
